import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import KeenSlider from "keen-slider";
import Mediabox from "mediabox";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
// registrar ScrollTrigger

//iniciar media box
Mediabox(".mediabox");

// iniciar keen-slider
var sliderElement = document.getElementById("my-keen-slider");
var leftArrow = document.getElementById("arrow-left");
var rightArrow = document.getElementById("arrow-right");
var interval = 0;
function autoplay(run) {
  clearInterval(interval);
  interval = setInterval(() => {
    if (run && slider) {
      slider.next();
    }
  }, 3500);
}

const slider = new KeenSlider(sliderElement, {
  loop: true,
  duration: 1000,
  created: function (instance) {
    console.log(instance);
    leftArrow.addEventListener("click", function () {
      instance.prev();
    });

    rightArrow.addEventListener("click", function () {
      instance.next();
    });

    updateClasses(instance);
  },
  slideChanged(instance) {
    updateClasses(instance);
  },
  dragStart: () => {
    autoplay(false);
  },
  dragEnd: () => {
    autoplay(true);
  },
});
sliderElement.addEventListener("mouseover", () => {
  autoplay(false);
});
sliderElement.addEventListener("mouseout", () => {
  autoplay(true);
});
autoplay(true);

// keen-slider arrows

function updateClasses(instance) {
  var slide = instance.details().relativeSlide;
  var arrowLeft = document.getElementById("arrow-left");
  var arrowRight = document.getElementById("arrow-right");
  slide === 0
    ? arrowLeft.classList.add("arrow--disabled")
    : arrowLeft.classList.remove("arrow--disabled");
  slide === instance.details().size - 1
    ? arrowRight.classList.add("arrow--disabled")
    : arrowRight.classList.remove("arrow--disabled");
}

// animación del menú
const menu = document.querySelector(".menuBtn");
const hamburger = document.querySelector(".hamburgerMenu");
const navigation = document.querySelector(".navigation");
const links = navigation.querySelectorAll("a");

// cerrar menu después de hacer click en algún link
links.forEach((link) =>
  link.addEventListener("click", () => {
    menu.classList.toggle("open");
    gsap.to(".navigation", {
      duration: 0.4,
      opacity: "0",
      ease: "ease.in",
    });
    gsap.to(".menuLayer", {
      duration: 0.5,
      delay: 0.3,
      marginLeft: "100%",
      ease: "ease.in",
    });
    gsap.to(".background", {
      duration: 0.5,
      delay: 0.5,
      marginLeft: "100%",
      ease: "ease.in",
    });
    gsap.to(".hamburgerMenu", {
      duration: 0.1,
      delay: 1,
      display: "none",
      ease: "ease.in",
    });
  })
);

menu.addEventListener("click", function (e) {
  this.classList.toggle("open");

  if (this.classList.contains("open")) {
    gsap.to(".hamburgerMenu", {
      duration: 0.1,
      display: "flex",
      ease: "ease.in",
    });
    gsap.to(".background", {
      duration: 0.5,
      delay: 0.3,
      marginLeft: "0",
      ease: "ease.in",
    });
    gsap.to(".menuLayer", {
      duration: 0.5,
      delay: 0.5,
      marginLeft: "0",
      ease: "ease.in",
    });
    gsap.to(".navigation", {
      duration: 0.4,
      delay: 1,
      opacity: "1",
      y: 0,
      ease: "ease.in",
    });
  } else {
    gsap.to(".navigation", {
      duration: 0.2,
      opacity: "0",
      y: "30px",
      ease: "ease.in",
    });
    gsap.to(".menuLayer", {
      duration: 0.5,
      delay: 0.3,
      marginLeft: "100%",
      ease: "ease.in",
    });
    gsap.to(".background", {
      duration: 0.5,
      delay: 0.5,
      marginLeft: "100%",
      ease: "ease.in",
    });
    gsap.to(".hamburgerMenu", {
      duration: 0.1,
      delay: 1,
      display: "none",
      ease: "ease.in",
    });
  }
});

// animacion producers dentro de contacto
const contacto = document.querySelector(".contacto");
const left = document.querySelector(".left-half");
const right = document.querySelector(".right-half");
const title = document.querySelector(".producer-title");
contacto.addEventListener("click", function () {
  console.log(title);
  if (window.innerWidth > 1020) {
    right.classList.toggle("resetY");
    left.classList.toggle("resetY");
    title.classList.toggle("opacity");
  }
});
